import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * ProgressBar component
 */
const ProgressBar = ({ className, ...props }) => {
  const {
    progress,
    ...otherProps
  } = props;

  const classNames = classnames(
    'progressbar',
    className,
  );

  return (
    <div className={classNames} {...otherProps}>
      <div className="progressbar__track" style={{ width: `${Math.min(Math.max(0, progress), 100)}%` }} />
    </div>
  );
};

ProgressBar.propTypes = {
  /** Additional classes. */
  className: PropTypes.string,
  /** Progressbar percentage, between 0 and 100 */
  progress: PropTypes.number.isRequired,
};

ProgressBar.defaultProps = {
  className: '',
};

export { ProgressBar };
